import InvoiceList from '../components/invoice/List'
import InvoiceCreate from '../components/invoice/Create'
import InvoiceUpdate from '../components/invoice/Update'

export default [
  {
    name: 'Invoice',
    path: '/invoices/',
    component: {template: '<router-view></router-view>'},
    redirect: {name: 'InvoiceList'},
    children: [
      {name: 'InvoiceList', path: '', component: InvoiceList},
      {name: 'InvoiceCreate', path: 'create', component: InvoiceCreate},
      {name: 'InvoiceUpdate', path: 'edit/:id', component: InvoiceUpdate}
    ]
  }
]
